<template>
  <div class="language-switcher">
    <a href="#" @click.prevent="toggle()">
      <span :class="{selected: locale === 'de'}">DE</span> |
      <span :class="{selected: locale === 'en'}">EN</span>
    </a>
  </div>
</template>
<style scoped lang="scss">
a {
  span.selected {
    font-weight: bold;
  }

  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }

  color: #fff !important;
  font-size: 25px;
}
</style>
<script>
import i18n from '@/i18n';

export default {
  name: 'LanguageSwitcher',
  props: {},
  data() {
    return {
      locale: i18n.locale
    };
  },
  watch: {
    '$i18n.locale' (newValue) {
      this.locale = newValue;
    }
  },
  methods: {
    toggle() {
      const newLocale = this.locale === 'de' ? 'en' : 'de';
      this.$ga.event('LanguageSwitcher', 'click', newLocale);

      const newRoutePath =
        `/${newLocale}` + this.$router.currentRoute.path.substr(this.locale.length + 1);
      this.$router.push({ path: newRoutePath });
    }
  }
};
</script>